<!--The content below is only a placeholder and can be replaced.-->
<form #loginForm="ngForm" (ngSubmit)="login()">
  <div style="text-align: center">
    <img src="assets/logo.jpeg" width="100" />
  </div>
  <div class="inputGroup inputGroup1" style="margin-bottom: 10px;"
    [class.has-success]="iptNome.valid && (iptNome.dirty || iptNome.touched)"
    [class.has-error]="!iptNome.valid && (iptNome.dirty || iptNome.touched)">
    <label for="email1">Usuário</label>
    <input type="text" id="nome" name="nome" [(ngModel)]="usuario.nome" #iptNome="ngModel" class="email" maxlength="256"
      required autocomplete="off" />
    <span class="help-block" *ngIf="!iptNome.valid && (iptNome.dirty || iptNome.touched)"><i
        class="fa fa-remove"></i>Informe o usuário!</span>
  </div>

  <div class="inputGroup inputGroup2">
    <label for="password">Senha</label>
    <input type="password" id="senha" name="senha" [(ngModel)]="usuario.senha" class="password" required
      autocomplete="off" />
  </div>

  <div class="inputGroup inputGroup3">
    <button class="btn btn-primary" style="background-color: #3c3c3c;" id="login" type="submit"
      [disabled]="loginForm.invalid">Login</button>
    <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" *ngIf="loading"></p-progressBar>
  </div>

</form>